export const useCORDSTeacherRoutesGenerator = () => {
  return {
    STUDENT: {
      LISTING: 'students',
      QUESTION: 'students/:recordId/assessment/:assessmentId'
    },
    PROFILE: 'profile'
  };
};
